import { useTranslation } from "react-i18next";

export default function WhatWeDo() {
  const { t } = useTranslation();

  return (
    <div className="bg-kag-bg text-white">
      {/* HERO */}
      <section className="bg-kag-bg">
        <div className="mx-auto w-full max-w-page px-5 sm:px-8 md:px-10 lg:px-[60px] pt-12 sm:pt-16 lg:pt-[85px] pb-10 sm:pb-14 lg:pb-[100px] text-center">
          <p className="font-clash text-kag-eyebrow text-[13px] sm:text-[15px] lg:text-[17px] leading-[1.2] uppercase tracking-[0.18em]">
            {t("whatWeDo.eyebrow")}
          </p>
          <h1 className="mt-5 lg:mt-7 font-clash font-medium text-white uppercase text-[56px] sm:text-[80px] md:text-[104px] lg:text-[128px] xl:text-[140px] leading-[0.98] tracking-tight">
            {t("whatWeDo.title")}
          </h1>
          <div className="mx-auto mt-6 lg:mt-9 max-w-[920px] font-clash text-[#b9b9b9] text-[14px] sm:text-[16px] lg:text-[18px] leading-[1.5]">
            <p>{t("whatWeDo.subtitle1")}</p>
            <p>{t("whatWeDo.subtitle2")}</p>
          </div>
        </div>
      </section>

      {/* OUR FOCUS — WHITE band */}
      <section className="bg-white text-black">
        <div className="mx-auto w-full max-w-page px-5 sm:px-8 md:px-10 lg:px-[60px] py-12 md:py-16 lg:py-[80px]">
          <h2 className="font-clash font-semibold text-black text-[28px] sm:text-[34px] md:text-[40px] lg:text-[46px] leading-[1] tracking-tight">
            {t("whatWeDo.focusTitle")}
          </h2>
          <p className="mt-5 lg:mt-7 font-clash font-medium text-[#8e8e8e] text-[14px] sm:text-[15px] lg:text-[17px] leading-[1.55] max-w-[1000px]">
            {t("whatWeDo.focusBody")}
          </p>
        </div>
      </section>

      {/* CORE AREAS — DARK */}
      <section className="bg-kag-bg">
        <div className="mx-auto w-full max-w-page px-5 sm:px-6 md:px-8 lg:px-8 py-12 md:py-14 lg:py-[72px]">
          <h2 className="text-center font-clash font-medium text-white uppercase text-[28px] sm:text-[34px] md:text-[40px] lg:text-[48px] leading-[1] tracking-tight">
            {t("whatWeDo.coreTitle")}
          </h2>
          <div className="mt-8 lg:mt-12 grid gap-5 lg:gap-6 lg:grid-cols-2">
            <CoreCard title={t("whatWeDo.core1Title")} body={t("whatWeDo.core1Body")} />
            <CoreCard title={t("whatWeDo.core2Title")} body={t("whatWeDo.core2Body")} />
            <CoreCard title={t("whatWeDo.core3Title")} body={t("whatWeDo.core3Body")} />
            <CoreCard title={t("whatWeDo.core4Title")} body={t("whatWeDo.core4Body")} />
          </div>
        </div>
      </section>

      {/* HOW WE THINK — WHITE with red accent */}
      <section className="bg-white text-black">
        <div className="mx-auto w-full max-w-page px-5 sm:px-8 md:px-10 lg:px-[60px] py-12 md:py-16 lg:py-[80px]">
          <div className="grid gap-7 lg:grid-cols-12 lg:gap-12 lg:items-start">
            <div className="lg:col-span-5 lg:text-right">
              <h2 className="font-clash font-semibold text-[#010f1f] text-[28px] sm:text-[34px] md:text-[40px] lg:text-[44px] leading-[1] tracking-tight">
                {t("whatWeDo.thinkTitle1")}<br />
                {t("whatWeDo.thinkTitle2")}
              </h2>
            </div>
            <div className="lg:col-span-7 border-l-[3px] lg:border-l-[5px] border-kag-red pl-5 lg:pl-7">
              <div className="font-clash font-normal text-[#8e8e8e] text-[14px] sm:text-[15px] lg:text-[16px] leading-[1.6] space-y-3 lg:space-y-4">
                <p>{t("whatWeDo.thinkP1")}</p>
                <p>{t("whatWeDo.thinkP2")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="h-12 bg-kag-bg" />
    </div>
  );
}

function CoreCard({ title, body }: { title: string; body: string }) {
  return (
    <div
      className="border-y border-l border-white/95 border-solid rounded-[24px] sm:rounded-[44px] lg:rounded-[56px] px-6 sm:px-10 lg:px-[56px] py-7 sm:py-9 lg:py-[44px]"
      style={{ borderRightWidth: 0, borderWidth: 1.006 }}
    >
      <div className="flex items-start gap-3 lg:gap-5">
        <span className="block bg-kag-red rounded-full mt-2 lg:mt-3 shrink-0 w-[12px] h-[12px] lg:w-[16px] lg:h-[16px]" />
        <h3 className="font-clash font-semibold text-white text-[24px] sm:text-[28px] md:text-[32px] lg:text-[38px] leading-[1.05] tracking-tight">
          {title}
        </h3>
      </div>
      <p className="mt-3 lg:mt-4 font-clash font-medium text-[#8e8e8e] text-[13px] sm:text-[14px] lg:text-[15px] leading-[1.55] max-w-[480px] pl-7 lg:pl-[36px]">
        {body}
      </p>
    </div>
  );
}
